/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input, output, OutputEmitterRef } from '@angular/core';
import { OpenDialogButtonComponent } from '@ods/component';
import { IconComponent } from '@ods/system';
import { DeleteListItemDialogData } from '../delete-list-item-dialog-container/delete-list-item-dialog-container.component';

@Component({
  selector: 'administration-delete-list-item-dialog-button',
  imports: [OpenDialogButtonComponent, IconComponent],
  templateUrl: './delete-list-item-dialog-button.component.html',
  host: { class: 'relative' },
})
export class DeleteListItemDialogButtonComponent {
  @Input() dialogData: DeleteListItemDialogData;
  public readonly clicked: OutputEmitterRef<void> = output<void>();
}
